import {CssDimensionRestDto, CssUnitDimensionRestDto} from "@/api/pharma-cms-content-page/models";
import {CssUnitDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssUnitDimensionRestDtoModel";

export class CssDimensionRestDtoModel implements CssDimensionRestDto {
    unit_dimension: CssUnitDimensionRestDto;

    constructor(unit_dimension: CssUnitDimensionRestDto) {
        this.unit_dimension = unit_dimension;
    }

    static createWithDefaults(): CssDimensionRestDtoModel {
        return new this(CssUnitDimensionRestDtoModel.createWithDefaults());
    }

    static cloneFrom(source: CssDimensionRestDto): CssDimensionRestDtoModel {
        return new this(CssUnitDimensionRestDtoModel.cloneFrom(source.unit_dimension));
    }
}
